import { Box, Flex } from "@chakra-ui/react";
import { Header } from "../Header/Header";
import { NavBar } from "../NavBar/NavBar";
import { useNavbar } from "../../context/NavbarContext";

export const Layout = ({ children }) => {
  const { isOpen } = useNavbar();

  return (
    <Flex height="100vh" width="100vw" overflow="hidden">
      <NavBar />
      <Flex
        direction="column"
        flex="1"
        height="100%"
        ml={isOpen ? "254px" : "80px"}
        transition="margin-left 0.3s ease"
        overflow="hidden"
      >
        <Box height="56px" width="100%" zIndex={10}>
          <Header />
        </Box>
        <Box
          width="100%"
          flex="1"
          maxHeight="100%"
          padding="20px 16px"
          backgroundColor="#f8fafc"
        >
          {children}
        </Box>
      </Flex>
    </Flex>
  );
};
